import { Box, Radio } from '@nimbus-ds/components';
import './TaskRadioCard.scss';

interface TaskRadioCardProps {
  task: { id: number; code: string; description?: string; label: string };
  selectedId: number | null;
  onChange: (id: number) => void;
  name: string;
  hasError?: boolean;
  isRevamp?: boolean;
}

export function TaskRadioCard({
  task,
  selectedId,
  onChange,
  name,
  hasError = false,
  isRevamp = false,
}: Readonly<TaskRadioCardProps>) {
  const boxShadow = isRevamp || hasError ? '0' : '2';

  return (
    <Box
      data-style="stratus--card-box"
      padding="4"
      borderRadius="2"
      borderStyle="solid"
      borderWidth="1"
      borderColor={hasError ? 'danger-interactive' : 'transparent'}
      data-variant={hasError && isRevamp ? 'light-danger' : undefined}
      boxShadow={boxShadow}
    >
      <Box display="flex" alignItems="center">
        <div className="stratus--radio-shadow">
          <Radio
            label={task.label}
            name={name}
            id={`${name}-${task.id}`}
            value={task.id.toString()}
            checked={selectedId === task.id}
            onChange={(e) => {
              if (e.target.checked) {
                onChange(task.id);
              }
            }}
          />
        </div>
      </Box>
    </Box>
  );
}
